import React from 'react';
import { Table, Typography } from 'antd';

import { buildVariantLabel } from '../Orders/AssortmentModal';

const { Text } = Typography;

// Same naming as the order PDF: product name followed by its variant's attribute values.
export const buildLineName = (line) =>
  `${line.product_name || ''} ${buildVariantLabel(line.variant)}`.trim() || '-';

// product_name_snapshot only stores the base product name, so the variant is
// what tells components apart.
const buildComponentName = (component) =>
  `${component.component_product?.name || component.product_name_snapshot || ''} ${buildVariantLabel(component.component_variant)}`.trim();

export const isAssorted = (line) => (line.components || []).length > 0;

// Same bridge the backend uses to value a component credit per stem.
export const componentStemsPerUnit = (unit, component) => {
  if (unit === 'STEM') return 1;
  if (unit === 'BUNCH') return Number(component.stems_per_bunch) || null;
  return null;
};

export const assortedStemsPerBillingUnit = (line) => {
  const stemsPerBox = line.components.reduce((sum, c) => sum + Number(c.bunches) * Number(c.stems_per_bunch), 0);
  const bunchesPerBox = line.components.reduce((sum, c) => sum + Number(c.bunches), 0);

  if (line.billing_unit === 'TALLO') return 1;
  if (line.billing_unit === 'RAMO') return bunchesPerBox ? stemsPerBox / bunchesPerBox : null;
  if (line.billing_unit === 'CAJA') return stemsPerBox || null;
  return null;
};

const formatCount = (value) => (Number(value) || 0).toLocaleString('es-CO');

// Recipe of an assorted box. There is no price per component: the price
// belongs to the whole line, so this table only shows quantities.
// `extraColumns` lets a screen append its own columns (e.g. credit inputs).
export const AssortmentBreakdown = ({ components, extraColumns = [] }) => {
  const baseColumns = [
    {
      title: 'Componente',
      key: 'name',
      render: (_, record) => buildComponentName(record),
    },
    {
      title: 'Ramos / caja',
      dataIndex: 'bunches',
      key: 'bunches',
      align: 'right',
      render: formatCount,
    },
    {
      title: 'Tallos / ramo',
      dataIndex: 'stems_per_bunch',
      key: 'stems_per_bunch',
      align: 'right',
      render: formatCount,
    },
    {
      title: 'Tallos / caja',
      key: 'stems',
      align: 'right',
      render: (_, record) => formatCount(Number(record.bunches) * Number(record.stems_per_bunch)),
    },
  ];
  const columns = [...baseColumns, ...extraColumns];

  const totalBunches = components.reduce((sum, c) => sum + Number(c.bunches), 0);
  const totalStems = components.reduce((sum, c) => sum + Number(c.bunches) * Number(c.stems_per_bunch), 0);

  return (
    <Table
      size="small"
      columns={columns}
      dataSource={components}
      rowKey={(record) => record.component_id}
      pagination={false}
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell index={0}><Text strong>Por caja</Text></Table.Summary.Cell>
          <Table.Summary.Cell index={1} align="right"><Text strong>{formatCount(totalBunches)}</Text></Table.Summary.Cell>
          <Table.Summary.Cell index={2} />
          <Table.Summary.Cell index={3} align="right"><Text strong>{formatCount(totalStems)}</Text></Table.Summary.Cell>
          {extraColumns.map((column, i) => (
            <Table.Summary.Cell key={column.key} index={baseColumns.length + i} />
          ))}
        </Table.Summary.Row>
      )}
    />
  );
};
